import { Component, OnInit, AfterContentInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import {MatMenuModule} from '@angular/material/menu';
import { environment } from 'src/environments/environment';
import { AppSettings } from 'src/app/_helpers/app.settings';
import { TokenStorageService } from 'src/app/_helpers/token-storage.service';
import { NotificationService } from 'src/app/_helpers/notification.service';
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit, AfterContentInit {
  
  AppSettings = AppSettings;
  apiToken: any = [];
  name: any;
  data: any;
  userObj: any;
  profilePicture: string;
  collapsed = true;
  navbarOpen: boolean = false;
  isUserLoggedIn: any;

  ssoUser: any;
  userRole: any;
  main_menu_items = AppSettings.MAIN_MENU_ITEMS;
  username:any='';
  
  constructor(
    private router: Router,
    private tokenStorage: TokenStorageService,
    private notificationService: NotificationService
    ) {
        this.profilePicture = 'assets/images/avatar.png';

    }
  ngOnInit(): void {
    this.username = this.tokenStorage.getUsername();
    this.userRole = this.tokenStorage.getUserRole();
    
  }
  ngAfterContentInit():void{

  }


  toggleNavbar() {
    this.navbarOpen = !this.navbarOpen;
  }

  logout(): void {
    this.tokenStorage.signOut("You have successfully signed out. Have a great day!");
    // this.notificationService.showSuccess("You have successfully signed out. Have a great day!");
    // this.router.navigate([AppSettings.LOGIN_ROUTE]);
  }
}
